// Imports
import React from 'react';
import styled from 'styled-components/macro';
import company from './shareables/company';


// Styled components
const Container = styled.footer`
	width: 80%;
	max-width: 450px;
	margin: 0 auto;
	padding: 1rem 0 3rem;
	text-align: center;
	color: #bbb;
	font-size: 0.8em;
	
	a {
		color: #656565;
		text-decoration: none;
		
		&:hover {
			text-decoration: underline;
		}
	}
`;

const GoogleNotice = styled.div`
	margin-top: 0.75em;
	font-size: 0.9em;
	line-height: 1.3;
	color: #aaa;
`;


// Function component
const Footer: React.FC = () => {
	return (
		<Container>
			<a
				href={`https://www.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/privacy-policy`}
				target='_blank'
				rel='noopener noreferrer'
			>
				Privacy
			</a>
			&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
			<a
				href={`https://www.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/terms-of-service`}
				target='_blank'
				rel='noopener noreferrer'
			>
				Terms
			</a>
			{company.productionDomain && (
				<React.Fragment>
					&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
					<a href={`https://help.${company.productionDomain}/`} target='_blank' rel='noopener noreferrer'>
						Help
					</a>
				</React.Fragment>
			)}
			&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
			<a
				href={`https://www.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/security`}
				target='_blank'
				rel='noopener noreferrer'
			>
				Security
			</a>
			<GoogleNotice>
				This site is protected by reCAPTCHA and the
				<br />
				Google{' '}
				<a href='https://policies.google.com/privacy' target='_blank' rel='noopener noreferrer'>
					Privacy Policy
				</a>{' '}
				and{' '}
				<a href='https://policies.google.com/terms' target='_blank' rel='noopener noreferrer'>
					Terms of Service
				</a>{' '}
				apply.
			</GoogleNotice>
		</Container>
	);
};

export default Footer;
